/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbVisiteFormateurGridDto } from './FcbVisiteFormateurGridDto';
import {
    FcbVisiteFormateurGridDtoFromJSON,
    FcbVisiteFormateurGridDtoFromJSONTyped,
    FcbVisiteFormateurGridDtoToJSON,
} from './FcbVisiteFormateurGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbVisiteFormateurGridDtoPaginatedResults
 */
export interface FcbVisiteFormateurGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbVisiteFormateurGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbVisiteFormateurGridDto>}
     * @memberof FcbVisiteFormateurGridDtoPaginatedResults
     */
    results?: Array<FcbVisiteFormateurGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbVisiteFormateurGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbVisiteFormateurGridDtoPaginatedResults interface.
 */
export function instanceOfFcbVisiteFormateurGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteFormateurGridDtoPaginatedResultsFromJSON(json: any): FcbVisiteFormateurGridDtoPaginatedResults {
    return FcbVisiteFormateurGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbVisiteFormateurGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteFormateurGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbVisiteFormateurGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbVisiteFormateurGridDtoPaginatedResultsToJSON(value?: FcbVisiteFormateurGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbVisiteFormateurGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

